export default __webpack_public_path__ + "static/media/customized1.2c449c5e.png";